export enum CommonRoute {
  ERROR = 'ErrorPage',
  NOT_FOUND = 'NotFoundPage',
  UNAUTHORIZED = 'UnauthorizedPage'
}
